import { render, staticRenderFns } from "./ReportsLanding.vue?vue&type=template&id=544c80a8&scoped=true"
import script from "./ReportsLanding.vue?vue&type=script&lang=js"
export * from "./ReportsLanding.vue?vue&type=script&lang=js"
import style0 from "./ReportsLanding.vue?vue&type=style&index=0&id=544c80a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544c80a8",
  null
  
)

export default component.exports